import { issueClientConnectionQualityWarning, photoUrlCommand } from "../../../LiveSwitch/liveSwitchActions";
import * as LiveSwitchTypes from "../../../LiveSwitch/liveSwitchActionTypes";
import { addSessionPhoto, addSessionPhotoPosition } from "../../../Shared/Auto/ApiDefinitions/ClientSessionService";
import { PhotoResult } from "../../../Shared/GeneratedTypes";
import { connectionQualityPingReceived, addConnectionWarning, clearConnectionWarnings } from "../../../Shared/Redux/Actions/sharedActions";
import { ApplicationData } from "../../types";

export function eventDrivenAPIMiddleware(store: any) {
    const { dispatch, getState } = store;
    return (next: any) => (action: any) => {
        var state: ApplicationData = getState();

        switch (action.type) {
            case LiveSwitchTypes.PHOTO_DATA_RECEIVED: {
                var timestamp = new Date();
                addSessionPhoto(action.id, action.photoData, state.accessInfo.token).then((result: PhotoResult) => {
                    dispatch(photoUrlCommand(action.id, result.url!, result.thumbnailUrl!));
                    if (state.currentPosition !== null) {
                        addSessionPhotoPosition(
                            action.id,
                            {
                                timeStamp: timestamp,
                                position: state.currentPosition as any,
                            },
                            state.accessInfo.token
                        );
                    }
                });
                break;
            }

            case LiveSwitchTypes.CONNECTION_QUALITY_PING: {
                const threshold = state.order.customer.connectionWarningThreshold;
                const drops = state.connectionQuality?.consecutiveDrops ?? 0;
                dispatch(connectionQualityPingReceived(action.connectionValue, drops));

                const connectionQuality = action.connectionValue;
                const isMyDevice = action.deviceId == state.deviceId;

                if (connectionQuality && isMyDevice) {
                    if (connectionQuality < threshold) {
                        dispatch(addConnectionWarning(connectionQuality, drops));
                        const msg = `Client connection quality dropped below threshold of ${threshold} to ${connectionQuality}. This is drop number ${drops}.`
                        logMessage(msg);
                    }
                    else {
                        dispatch(clearConnectionWarnings(connectionQuality ?? 100, drops));
                    }
                }

                if (drops > 1) {
                    dispatch(issueClientConnectionQualityWarning());
                }

                break;
            }
        }
        return next(action);
    };
}

function logMessage(message: string) {
    var anyW = window as any;
    if (anyW.appInsights) {
        anyW.appInsights.trackTrace({ message: message, severityLevel: 1 });
    }
}
